/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { EventPayload } from './eventPayload';

export interface ActivityLogEvent { 
    event_id: string;
    event_datetime: Date;
    event_type: ActivityLogEvent.EventTypeEnum;
    event_payload: EventPayload;
}
export namespace ActivityLogEvent {
    export type EventTypeEnum = 'FilesUploadedEvent' | 'FileShared' | 'FileDownloaded' | 'FileRemoved' | 'FileUnshared' | 'FilePermissionUpdated';
    export const EventTypeEnum = {
        FilesUploadedEvent: 'FilesUploadedEvent' as EventTypeEnum,
        FileShared: 'FileShared' as EventTypeEnum,
        FileDownloaded: 'FileDownloaded' as EventTypeEnum,
        FileRemoved: 'FileRemoved' as EventTypeEnum,
        FileUnshared: 'FileUnshared' as EventTypeEnum,
        FilePermissionUpdated: 'FilePermissionUpdated' as EventTypeEnum
    };
}